/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import useCalendars from '../../../../hooks/useCalendars';


const Calendar = ({
  activeLanguage, handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'Calendar',
    title: {
      en: '',
    },
    intent: 'withCalendarName',
    calendarIds: [],
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const [title, setTitle] = useState({ en: '' });
  const [intent, setIntent] = useState('withCalendarName');
  const [calendarIds, setCalendarIds] = useState([]);

  const options = useCalendars();

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        const {
          title: currentTitle,
          intent: currentIntent,
          calendarIds: currentCalendarIds,
        } = component;

        setState(component);
        setTitle(currentTitle);
        setIntent(currentIntent);
        setCalendarIds(currentCalendarIds);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      title: { ...title },
      intent,
      calendarIds,
    };
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    title, intent, calendarIds,
  ]);

  return (
    <div className="max-w-xl space-y-6 p-6 bg-white rounded-xl shadow-sm text-black">

      {/* Title */}
      <div className="mb-5">
        <label className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
          Title
        </label>
        <input
          type="text"
          onChange={
            (e) => {
              title[activeLanguage] = e.target.value;
              setTitle({ ...title });
            }
          }
          value={title[activeLanguage] || ''}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm
                   focus:border-blue-500 focus:ring-2 focus:ring-blue-200
                   focus:outline-none transition"
        />
      </div>
      <div className="mb-5">
        <label className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
          variant
        </label>
        <select
          value={intent}
          onChange={(e) => setIntent(e.target.value)}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm
                   focus:border-blue-500 focus:ring-2 focus:ring-blue-200
                   focus:outline-none transition"
        >
          <option value="withCalendarName">Full Page</option>
          <option value="simple">In Page</option>
        </select>
      </div>
      <div className="mb-5">
        <label className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
          Calendars
        </label>
        <select
          multiple
          value={calendarIds}
          onChange={(e) => {
            const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
            setCalendarIds(selectedOptions);
          }}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm
             focus:border-blue-500 focus:ring-2 focus:ring-blue-200
             focus:outline-none transition"
        >
          {options.map(op => (
            <option key={op.value} value={op.value}>{op.label || op.value}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

Calendar.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};
Calendar.defaultProps = {
  reusableComponent: null,
};

export default Calendar;
